import { Email } from '@mui/icons-material';
import { TextField, type TextFieldProps } from '@mui/material';
import React, { useMemo } from 'react';
import { FaviconDomainInput } from '~/components/FaviconDomainInput';
import { isEmail } from '~/scripts/isEmail';

interface EmailInputProps extends Omit<TextFieldProps, ''> {
  setValue: (value: string) => void;
}
export const EmailInput = ({
  value,
  setValue,
  ...TextFieldProps
}: EmailInputProps) => {
  const { slotProps, placeholder, ...textFieldProps } = TextFieldProps;

  const isValidEmail = useMemo(() => isEmail(value?.toString() || ''), [value]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target.value || '').trim());
  };

  return (
    <TextField
      label="Email Address"
      error={!!value && !isValidEmail}
      name="email"
      type="email"
      value={value}
      onChange={onChange}
      autoComplete="username"
      placeholder={placeholder || 'you@company.com'}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          startAdornment: (
            <FaviconDomainInput
              value={value?.toString()}
              fallback={<Email />}
            />
          ),
        },
      }}
      {...textFieldProps}
    />
  );
};
